import "core-js/modules/es.string.anchor";
import React from "react";
import PropTypes from "prop-types";
import Expandable from "web/react/components/expandable/expandable";
import analytics from "web/script/analytics/analytics";
import style from "./product-description-price-history-bullet.css";

function ProductDescriptionPriceHistoryBullet(_ref) {
  var className = _ref.className,
      priceHistoryBullet = _ref.priceHistoryBullet,
      productAreaAccordions = _ref.productAreaAccordions;
  return productAreaAccordions ? React.createElement("div", {
    className: className
  }, React.createElement(Expandable, {
    renderLabel: function renderLabel() {
      return React.createElement("h4", null, "Price History");
    } // TODO: i18n
    ,
    onClick: function onClick(isOpen) {
      if (!isOpen) {
        analytics.event("product area", "click", "open-priceHistory");
      }
    }
  }, React.createElement("p", null, priceHistoryBullet, " "
  /* we need a single whitespace here */
  , React.createElement("a", {
    className: style.anchor,
    href: "#price-history"
  }, "See price and stock history." // TODO: i18n
  )))) : React.createElement("div", {
    className: className
  }, React.createElement("h4", {
    className: style.title
  }, "Price History" // TODO: i18n
  ), React.createElement("p", null, priceHistoryBullet, " "
  /* we need a single whitespace here */
  , React.createElement("a", {
    className: style.anchor,
    href: "#price-history"
  }, "See price and stock history." // TODO: i18n
  )));
}

ProductDescriptionPriceHistoryBullet.propTypes = {
  className: PropTypes.string,
  priceHistoryBullet: PropTypes.string.isRequired,
  productAreaAccordions: PropTypes.bool
};
export default ProductDescriptionPriceHistoryBullet;